import {ref} from 'vue'
import {defineStore} from 'pinia'
import {log} from "@/components/utils/HComFunctions.js";
import {hsp, SaveEnum} from "@/components/utils/HSp.js";
import {hr} from "@/components/utils/HRouter.js";
import {hdi} from "@/components/utils/HDeviceInfo.js";

export const useUserStore = defineStore('user', () => {
    let userName = ref('');
    let avatar = ref('');
    let userId = ref("");
    let showUserId = ref("");
    let appId = ref("");
    let token = ref("");
    let phoneNumber = ref("");
    let areaCode = ref("");
    let totalMoney = ref("0.0");
    let availableMoney = ref("0.0");
    let inviteCode = ref("");
    let realName = ref("");
    let birthday = ref("");
    let gender = ref(0);
    let isLogin = ref(false);
    let isHaveSafePwd = ref(false);
    let isHavePwd = ref(false);
    let addressList = ref([]);
    let withdrawMap = ref({
        "1": [], //银行卡
        "2": [], //USDT
        "3": [], //支付宝
        "4": [], //微信
        "5": [], //NOPAY
        "6": [], //GOPAY
        "7": [], //EBPAY
        "8": [], //波币
        "9": [], //K豆
        "10": [], //万币
        "11": [], //钱能
        "12": [], //ABPAY
        "13": [], //OKPAY
        "14": [], //C币钱包
        "15": [], //JD钱包
        "16": [], //365PAY
        "17": [], //红豆PAY
    });
    //新字段
    let vipLevel = ref(0);
    let currentExp = ref(0);
    let nextExp = ref(0);
    let alipayAccount = ref("");

    // 注意是客户端字段不要直接扔服务器字段
    function updateUserRefs(userPatchMap) {
        this.$patch(userPatchMap);
    }

    function removeUserInfo() {
        hsp.remove(SaveEnum.userId);
        hsp.remove(SaveEnum.userToken);
        userName.value = '';
        avatar.value = '';
        userId.value = '';
        showUserId.value = '';
        appId.value = '';
        token.value = '';
        phoneNumber.value = '';
        areaCode.value = '';
        totalMoney.value = "0.0";
        availableMoney.value = "0.0";
        inviteCode.value = '';
        realName.value = '';
        birthday.value = '';
        gender.value = 0;
        isLogin.value = false;
        isHaveSafePwd.value = false;
        isHavePwd.value = false;
        addressList.value = [];
        withdrawMap.value = {
            "1": [], "2": [], "3": [], "4": [], "5": [], "6": [], "7": [], "8": [], "9": [], "10": [],
            "11": [], "12": [], "13": [], "14": [], "15": [], "16": [], "17": [],
        };
        vipLevel.value = 0;
        currentExp.value = 0;
        nextExp.value = 0;
        alipayAccount.value = '';
    }

    //监听数据变化
    // this.$subscribe()

    function checkIsLoginGo(routerName, params = {}) {
        if (isLogin.value) {
            hr.go(routerName, params);
        } else {
            hr.go("login");
        }
    }

    function checkCanOptimizationCount() {
        let optimizationCount = 0;

        if (hdi.channelFlag === "main") {
            if (phoneNumber.value === "") {
                optimizationCount++;
            }
        }
        if (!("1" in withdrawMap.value) ||
            withdrawMap.value["1"] == null ||
            withdrawMap.value["1"].length <= 0) {
            optimizationCount++;
        }
        if (!isHaveSafePwd.value) {
            optimizationCount++;
        }
        if (!isHavePwd.value) {
            optimizationCount++;
        }
        return optimizationCount;
    }

    return {
        userName, avatar, userId, showUserId, appId, token, phoneNumber, areaCode, totalMoney, availableMoney,
        inviteCode, realName, birthday, gender, isLogin, isHaveSafePwd, isHavePwd, addressList, withdrawMap, vipLevel,
        currentExp, nextExp, alipayAccount,
        updateUserRefs, removeUserInfo, checkIsLoginGo, checkCanOptimizationCount
    }
})
